export const locale = {
    lang: 'es',
    data: {
        FORM_VALIDATION: {
            REQUIRED: 'Campo obligatorio',
            INVALID_DATE: 'Campo debe tener el formato {{ format }}',
            MAX_DATE: 'Campo debe ser como máximo {{ max }}',
            MIN_DATE: 'Campo debe ser como mínimo {{ min }}',
            NOT_WEEKEND: 'Campo no permite fin de semana',
            URL: 'Campo debe ser una URL válida',
            EMAIL: 'Campo debe ser un email válido',
            MIN_LENGTH: 'Campo debe tener como mínimo {{ min }} caracteres',
            MAX_LENGTH: 'Campo debe tener como máximo {{ max }} caracteres',
            NUMBER: 'Campo debe ser un número',
            NUMBER_INTEGER: 'El campo debe ser un número entero',
            MAX_NUMBER: 'Campo debe ser como máximo {{ max }}',
            MIN_NUMBER: 'Campo debe ser como mínimo {{ min }}',
            LETTER_AND_NUMBER: 'El campo solo permite letras y números',
            MASK: 'El campo debe tener el formato correcto',
            UUID: 'Campo debe ser un UUID',
            LETTER: 'Campo permite solo letras',
            DISABLE_MINUTE: 'Campo no permite minutos',
            REGEXP: 'Campo no cumple con el formato esperado',
            INVALID_DOCUMENT: 'Documento inválido',
            MUST_MATCH: 'Los campos no coinciden',
            MINIMUM_TWO_NAMES: 'Introduzca el nombre completo (nombre y apellido)',
            DUPLICATE_NAMES_NOT_ALLOWED: 'El nombre y el apellido no pueden ser iguales',
            STRONG_PASSWORD: 'La contraseña debe contener al menos una letra mayúscula, una minúscula, un número y un carácter especial',
            CARD_NUMBER_INVALID: 'Número de tarjeta inválido',
        },
    },
};
